import { render, staticRenderFns } from "./OnboardMessaging.vue?vue&type=template&id=dea879b0"
import script from "./OnboardMessaging.vue?vue&type=script&lang=ts"
export * from "./OnboardMessaging.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports